export default __webpack_public_path__ + "static/media/ftm_logo_light.be331fde.svg";